import { Engine } from "./Engine";
import { Entity } from "./Entity";

type Constructor<T = {}> = new (...args: any[]) => T;

/**
 * @deprecated Use viewport-local TypedEventHub, CommandRegistry, or InputRouter
 * subscriptions for new capabilities. Existing product entities remain
 * supported until they are migrated explicitly.
 */
export function registerEvents(...events: string[]) {
  return function <T extends Constructor<Entity>>(Base: T) {
    return class extends Base {
      private __registerevents: string[] = [];
      private __registeredevents: any = {};

      constructor(...args: any[]) {
        super(...args);
        this.__registeredevents = [...args];
        this.__registerevents = events;
      }

      onAdd(engine: Engine): void {
        super.onAdd(engine);
        for (const type of this.__registerevents) {
          const binding = ((e: any) => {
            const methodName =
              "on" +
              type.split("-").reduce((prev, cur) => {
                return prev + cur[0].toUpperCase() + cur.slice(1);
              }, "") +
              "Occured";
            const handler = (this as any)[methodName];
            if (typeof handler === "function") handler.call(this, e);
          }).bind(this);
          if (
            type === "dragover" ||
            type === "drop" ||
            type == "click" ||
            type == "pointerdown" ||
            type == "pointermove" ||
            type == "pointerup"
          ) {
            engine.canvas.addEventListener(type, binding);
          } else if (type === "keyup" || type === "keydown") {
            window.addEventListener(type, binding);
          } else {
            engine.addEventListener(type, binding);
          }

          this.__registeredevents[type] = binding;
        }
      }

      onRemove(engine: Engine): void {
        super.onRemove(engine);
        for (const type of Object.keys(this.__registeredevents)) {
          if (
            type === "dragover" ||
            type === "drop" ||
            type === "click" ||
            type === "pointerdown" ||
            type === "pointermove" ||
            type === "pointerup"
          ) {
            engine.canvas.removeEventListener(
              type,
              this.__registeredevents[type],
            );
          } else if (type === "keyup" || type === "keydown") {
            window.removeEventListener(type, this.__registeredevents[type]);
          } else {
            engine.removeEventListener(type, this.__registeredevents[type]);
          }
        }
        this.__registeredevents = [];
      }

      set enabled(value: boolean) {
        if (super.enabled == value) {
          return;
        }
        super.enabled = value;
        if (value) this.onAdd(this.engine!);
        else this.onRemove(this.engine!);
      }
    };
  };
}
